import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../components/navbar/navbar.js';
import { Sidebar } from '../components/sidebar/sidebar.js';
import './style.css';

const MainLayout = () => {
  return (
    <div className="content-container">
      <div className="sidebar-container">
        <Sidebar />
      </div>
      <div className="main-container">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;